<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Spring næste opkrævning over</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  @if (!agreementEndsInterval) {
    <p class="orange med-text align-center">
      <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
      <br />
      Dette vil betyde, at kunden aldrig opkræves yderligere for
      <br />
      perioden {{ intervalStart | date: 'dd.MM.yyyy' }} - {{ intervalEnd | date: 'dd.MM.yyyy' }}.
    </p>
  }
  @if (agreementEndsInterval) {
    <p class="orange med-text align-center">
      <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
      <br />
      Aftalen er opsagt, og dette vil derfor betyde, at kunden ikke opkræves yderligere.
    </p>
  }
  <p class="med-text align-center">Vil du fortsætte?</p>
  <form [formGroup]="form" autocomplete="off">
    <div class="form-row">
      <mat-form-field appearance="outline">
        <mat-label>Begrundelse</mat-label>
        <input formControlName="causeRemark" matInput />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Spring over</button>
  <button (click)="cancel()" class="modal-cancel" mat-raised-button>Fortryd</button>
</div>
